const state = () => ({
  provinces: null,
})
const getters = {
  provinces: (state) => state.provinces,
}
const mutations = {
  receiveProvinces(state, provinces) {
    state.provinces = provinces
  },
}
const actions = {
  getProvinces({ commit, rootState }) {
    return this.$axios
      .post('/akern-platform-backend/v1/common/province/list')
      .then((response) => {
        const formattedProvinces = response.data.provinces.map((p) => ({
          id: p.id,
          name: p.name
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' '),
        }))
        commit('receiveProvinces', formattedProvinces)
      })
  },
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
